<div class="sector-settings">
  <div class="sidebar">
    <div class="sidebar-header">
      <h2>Secteurs</h2>
      <p class="hint">
        Dessinez des zones sur la carte pour filtrer la programmation secteur
        par secteur.
      </p>
      <button
        type="button"
        class="map-toggle"
        [class.active]="showHomes"
        (click)="toggleHomes()"
        [title]="
          (showHomes ? 'Masquer' : 'Afficher') + ' les domiciles techniciens'
        "
      >
        <i class="pi" [ngClass]="showHomes ? 'pi-eye' : 'pi-eye-slash'"></i>
        <span>Domiciles techniciens ({{ technicianHomes.length }})</span>
      </button>
      <button
        type="button"
        class="map-toggle"
        [class.active]="showDepartments"
        (click)="toggleDepartments()"
        [title]="
          (showDepartments ? 'Masquer' : 'Afficher') +
          ' les limites de départements'
        "
      >
        <i
          class="pi"
          [ngClass]="showDepartments ? 'pi-eye' : 'pi-eye-slash'"
        ></i>
        <span>Limites de départements</span>
      </button>
    </div>

    <!-- Formulaire de création / édition -->
    <div class="draft-form" *ngIf="mode !== 'idle'">
      <label class="field">
        <span>Nom du secteur</span>
        <input
          type="text"
          [(ngModel)]="draftName"
          placeholder="Ex : Grand Sud-Ouest"
          maxlength="255"
        />
      </label>

      <label class="field">
        <span>Couleur</span>
        <div class="palette">
          <button
            *ngFor="let c of palette"
            type="button"
            class="swatch"
            [style.background]="c"
            [class.selected]="c === draftColor"
            (click)="onColorChange(c)"
            [attr.aria-label]="'Couleur ' + c"
          ></button>
          <label
            class="swatch custom"
            [class.selected]="!palette.includes(draftColor)"
            [style.background]="draftColor"
            title="Couleur personnalisée"
          >
            <i class="pi pi-plus"></i>
            <input
              type="color"
              [ngModel]="draftColor"
              (ngModelChange)="onColorChange($event)"
            />
          </label>
        </div>
      </label>

      <label class="field">
        <span>Techniciens du secteur</span>
        <p-multiSelect
          #techSelect
          [options]="technicians"
          [(ngModel)]="draftUserIds"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [resetFilterOnHide]="true"
          appendTo="body"
          [style]="{ width: '100%' }"
          placeholder="Aucun technicien rattaché"
          display="chip"
          emptyMessage="Aucun technicien"
          (onChange)="techSelect.resetFilter()"
        ></p-multiSelect>
      </label>

      <p class="hint" *ngIf="mode === 'creating'">
        Cliquez sur la carte pour tracer les sommets, puis double-cliquez pour
        fermer le polygone.
      </p>

      <div class="actions">
        <p-button
          label="Enregistrer"
          icon="pi pi-check"
          [loading]="saving"
          (onClick)="save()"
        ></p-button>
        <p-button
          label="Annuler"
          severity="secondary"
          [text]="true"
          (onClick)="cancel()"
        ></p-button>
      </div>
    </div>

    <!-- Bouton nouveau secteur -->
    <div class="new-sector" *ngIf="mode === 'idle'">
      <p-button
        label="Nouveau secteur"
        icon="pi pi-plus"
        (onClick)="startCreate()"
      ></p-button>
    </div>

    <!-- Liste des secteurs -->
    <div class="sector-list" *ngIf="!loading">
      <div
        *ngFor="let sector of sectors"
        class="sector-item"
        [class.active]="sector.id === selectedId"
      >
        <div class="sector-row">
          <span class="color-dot" [style.background]="sector.color"></span>
          <span class="name" (click)="startEdit(sector)">{{
            sector.name
          }}</span>
          <span
            class="tech-count"
            [class.empty]="!sector.users?.length"
            [title]="(sector.users?.length || 0) + ' technicien(s) rattaché(s)'"
          >
            <i class="pi pi-users"></i> {{ sector.users?.length || 0 }}
          </span>
          <button
            type="button"
            class="icon-btn"
            title="Modifier"
            (click)="startEdit(sector)"
          >
            <i class="pi pi-pencil"></i>
          </button>
          <button
            type="button"
            class="icon-btn danger"
            title="Supprimer"
            (click)="remove(sector)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>

        <!-- Techniciens rattachés -->
        <div class="sector-techs" *ngIf="sector.users?.length; else noTech">
          <span
            *ngFor="let tech of sector.users"
            class="tech-chip"
            [style.background]="tech.color || sector.color || '#64748b'"
            [pTooltip]="tech.fullName"
            tooltipPosition="top"
          >
            {{ tech.initials }}
          </span>
        </div>
        <ng-template #noTech>
          <p class="sector-techs-empty">Aucun technicien rattaché</p>
        </ng-template>
      </div>

      <p class="empty" *ngIf="sectors.length === 0">
        Aucun secteur défini pour le moment.
      </p>
    </div>

    <div class="loading" *ngIf="loading">
      <p-progressSpinner styleClass="spinner-sm"></p-progressSpinner>
    </div>
  </div>

  <div #mapContainer class="map"></div>
</div>
